import { render, staticRenderFns } from "./ZyReturn.vue?vue&type=template&id=3dc3f65e&scoped=true"
import script from "./ZyReturn.vue?vue&type=script&lang=js"
export * from "./ZyReturn.vue?vue&type=script&lang=js"
import style0 from "./ZyReturn.vue?vue&type=style&index=0&id=3dc3f65e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3f65e",
  null
  
)

export default component.exports